export const dataExtractor = (data, topic, topicOptions, answer) => {
  const dataNeeded = {
    chart: [],
    text: []
  };

  // If no data, return blank object
  if (!data) return dataNeeded;

  // Loop over customEvents and get the data for the modal click events
  Object.keys(data.customEvents).map(item => {

    // If the 'Yes' option is selected, show the stats for the choosen options
    if (answer === 'yes') {
      // If the topic being viewed is available and it is of type 'Modal option'
      if (item.includes(topic) && item.includes('Modal option')) {
        // If the 'Modal options' found include those options available for the topic being viewed
        if (topicOptions.some(function (v) { return item.indexOf(v) >= 0; })) {

          // Construct the object model
          const model = {
            title: item.split(' ')[3],
            value: data.customEvents[item],
          }

          // Push it to the array
          dataNeeded.chart.push(model)
        }
      }
    }

    // If the 'No' option is selected, show the stat comparison for overall yes/no answers
    if (answer === 'no') {
      if (item.includes(topic) && item.includes('Answered')) {
        // Construct the object model
        const model = {
          title: item.split(' ')[2].charAt(0).toUpperCase() + item.split(' ')[2].slice(1),
          value: data.customEvents[item],
        }

        // Push it to the array
        dataNeeded.chart.push(model)
      }
    }


    return null;
  });

  // If both data types are available
  if (dataNeeded.chart.length === 2) {

    // Use shades of blue if the 'Yes' answer is selected
    if (answer === 'yes') {
      // Set colours
      dataNeeded.chart[0].color = '#2196F3';
      dataNeeded.chart[1].color = '#BBDEFB';
    }

    // Use green/red if the 'No' answer is selected
    if (answer === 'no') {
      // Set colours
      if (dataNeeded.chart[0].title === 'No') {
        dataNeeded.chart[0].color = '#ffb0b0';
        dataNeeded.chart[1].color = '#559c94';
      }

      if (dataNeeded.chart[1].title === 'No') {
        dataNeeded.chart[0].color = '#559c94';
        dataNeeded.chart[1].color = '#ffb0b0';
      }
    }

    // Set text data
    const total = dataNeeded.chart[0].value + dataNeeded.chart[1].value;

    dataNeeded.text = [{
      name: dataNeeded.chart[0].title,
      color: dataNeeded.chart[0].color,
      total: Math.round((dataNeeded.chart[0].value / total) * 100)
    },
    {
      name: dataNeeded.chart[1].title,
      color: dataNeeded.chart[1].color,
      total: Math.round((dataNeeded.chart[1].value / total) * 100)
    }];
  }

  return dataNeeded;
};